import script from "./BannersSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./BannersSection.vue?vue&type=script&setup=true&lang=ts"

import "./BannersSection.vue?vue&type=style&index=0&id=ddff7a06&lang=scss"

const __exports__ = script;

export default __exports__